import { Card, Text, Title } from "@clipboard-health/ui-components";
import { CardActionArea, CardContent, Stack } from "@mui/material";

interface CbhWrappedBannerProps {
  onClick: () => void;
}

// eslint-disable-next-line no-restricted-syntax
const BACKGROUND_COLOR = "#FF7F8C";

export function CbhWrappedBanner(props: CbhWrappedBannerProps) {
  const { onClick } = props;

  return (
    <Card sx={{ background: BACKGROUND_COLOR }}>
      <CardActionArea onClick={onClick}>
        <CardContent>
          <Stack direction="column" alignItems="flex-start">
            <Title
              semibold
              variant="h4"
              component="h6"
              sx={(theme) => ({
                textWrap: "balance",
                color: theme.palette.text.invertPrimary,
                whiteSpace: "pre",
              })}
            >
              🎉 Your 2025 Mid-Year Recap!
            </Title>

            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.invertPrimary, marginY: 3 })}
            >
              You&apos;re one of our top 1,000 performers this year! Tap here to see your highlights
              and celebrate everything you accomplished.
            </Text>

            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.invertPrimary })}
            >
              Thanks for being a valued part of the Clipboard Health family!
            </Text>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
